import { Select2Model } from '~/components/Select2Model';
import { Select2Brand } from '~/components/Select2Brand';
import { InputSerialNumber } from '~/components/InputSerialNumber';
import { RequestsListBySerialNumber } from '~/components/RequestsListBySerialNumber';
import { s_r_n as lang } from '~/lang/ru';
import { WarrantyModalToggle, WarrantyModal } from './WarrantyModal';
import {Select2Importer} from "~/components/Select2Importer";

/**
 * @typedef {object} Data
 * @property {import('~/api/getBrands').Brand | null} brand
 * @property {string | null} modelId
 * @property {string | null} serialNumber
 */

/**
 * @typedef {object} Computed
 * @property {string | undefined} brandId
 * @property {boolean} isBrandSelected
 * @property {string | null} serialNumberMask
 * @property {boolean} isSerialNumberRequired
 */

/** @type {import('vue/types/options').ThisTypedComponentOptionsWithRecordProps<{}, Data, {}, Computed, {}>}*/
export const ServiceRequestNewFormProductInfo = {
	name: 'ServiceRequestNewFormProductInfo',
	data: (vm) => ({
		importer: null,
		brand: null,
		modelId: null,
		serialNumber: null,
	}),
	computed: {
		brandId: function () {
			return this.brand?.id;
		},
		isBrandSelected: function () {
			return this.brand === null;
		},
		serialNumberMask: function () {
			return this.brand?.SERIAL_MASK;
		},
		isSerialNumberRequired: function () {
			return this.brand?.SERIAL_REQUIRED;
		},
		serialPattern: function () {
			// Hack. HTML input checkValidity() always returns true even with minlength violations in js
			return this.brand?.SERIAL_MASK.length > 0 ?
				'^.{' + this.brand?.SERIAL_MASK.length + ',}$' : false
		},
	},
	watch: {
		brandId: function () {
			this.modelId = null;
			this.serialNumber = null;
		},
	},
	render(h) {
		return (
			<div>
				<Select2Importer
					class="mb-6"
					ref="importerSelect"
					name="IMPORTER"
					data-placeholder={lang('SELECT_IMPORTER')}
					label={lang('IMPORTER')}
					error-message="Выберите импортёра"
					vOn:select={(data) => {
						this.importer = data;
					}}
				/>
				<Select2Brand
					class="mb-6"
					ref="brandSelect"
					required
					name="BRAND"
					data-placeholder={lang('SELECT_BRAND')}
					label={lang('BRAND')}
					error-message="Выберите производителя"
					vOn:select={(data) => {
						this.brand = data;
						this.$refs.brandSelect.checkValidity?.();
					}}
				/>

				<Select2Model
					class="mb-6"
					required
					name="MODEL"
					disabled={this.isBrandSelected}
					label={lang('MODEL')}
					brand-id={this.brandId}
					value={this.modelId}
					error-message="Выберите модель"
					vOn:select={(data) => this.modelId = data.id}
				/>

				<div class="mb-6">
					<div class="relative">
						<InputSerialNumber
							class="mb-2"
							type="text"
							name="SERIAL_NUMBER"
							autocomplete="off"
							placeholder={this.serialNumberMask}
							mask={this.serialNumberMask}
							label={lang('SERIAL_NUMBER')}
							vModel_trim={this.serialNumber}
							required={this.isSerialNumberRequired}
							pattern={this.serialPattern}
							error-message="Пожалуйста, заполните серийный номер"
						/>
						<WarrantyModalToggle
							brand-id={this.brandId}
							class="ml-5"
							style={{
								'position': 'absolute',
								'bottom': '0',
								'left': '100%',
								'white-space': 'nowrap',
							}}
						/>
					</div>

					<RequestsListBySerialNumber
						serialNumber={this.serialNumber}
					/>

					<WarrantyModal
						brandId={this.brandId}
						serialNumber={this.serialNumber}
					/>
				</div>
			</div>
		);
	}
}
